import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Route as ReactRoute } from 'react-router'
import { Redirect } from 'react-router-dom'
import AuthActions from 'store/redux/auth'

@connect(
    state => ({
        type: state.auth.type,
        isAuthenticated: state.auth.isAuthenticated,
        user: state.auth.user,
        prevLocation: state.routerData.prevLocation
    }),
    {
        signout: AuthActions.signout,
    }
)
class Route extends Component {
    redirect = pathname => renderProps => <Redirect to={{ pathname, state: { from: renderProps.location } }} />

    renderFunction(type, path, secured, guest, isAuthenticated, user, mc, admin, prevLocation, RouteComponent, signout) {
        if (isAuthenticated && ((mc && type !== 'admin') || (admin && type !== 'superadmin') || (user && type !== 'player'))) {
            signout(false)
        } else {
            if (mc && secured && !isAuthenticated) {
                return this.redirect('/mc/signin')
            }
            if (mc && guest && isAuthenticated) {
                return this.redirect('/mc')
            }
            if (admin && secured && !isAuthenticated) {
                return this.redirect('/admin/signin')
            }
            if (admin && guest && isAuthenticated) {
                return this.redirect('/admin')
            }
            if (secured && !isAuthenticated) {
                return this.redirect('/new-game')
            }
            if (guest && isAuthenticated) {
                // return this.redirect('/tour')
            }
        }
        return renderProps => <RouteComponent {...renderProps} />
    }

    render() {
        const { type, path, secured, guest, isAuthenticated, user, mc, admin, component, prevLocation, signout, ...props } = this.props

        return <ReactRoute path={path} render={this.renderFunction(type, path, secured, guest, isAuthenticated, user, mc, admin, prevLocation, component, signout)} {...props} />
    }
}

export default Route



// WEBPACK FOOTER //
// src/router/Route.js